import React, { useState, memo, useEffect } from 'react';
import _get from 'lodash/get';
import _isUndefined from 'lodash/isUndefined';
import _truncate from 'lodash/truncate';
import useCategory from '@hooks/use-category';
import { ICategory } from '@server/data/models/category';
import LazyImage from '@views/components/lazy-image';
import { categoryHref, INTERNAL_URI } from '@helpers/route';
import cn from 'classnames';
import {
  Flex,
  SidebarWrapper,
  SidebarContainer,
  SidebarItem,
  ContentWrapper,
  ContentLink,
  ContentContainer,
  ContentItem,
  HelperLink,
} from './styles';

const remapData = (data: ICategory[]) => {
  const mainData = data.filter((item) => _get(item, 'parentId') == 1);
  const mapSubData = {};
  mainData.forEach((parent) => {
    const categoryId = _get(parent, 'id');
    if (_isUndefined(mapSubData[categoryId])) {
      mapSubData[categoryId] = {
        root: parent,
        items: data.filter((child) => _get(child, 'parentId') == categoryId),
      };
    }
  });

  return { mainData, mapSubData };
};

const UNDEFINED_ID = 999;
const Sitemap = () => {
  const { loading, error, categories } = useCategory();
  const [activeId, setActiveId] = useState(UNDEFINED_ID);
  const haveSub = activeId !== UNDEFINED_ID;
  // @ts-ignore
  const { mainData, mapSubData } = remapData(categories);
  useEffect(() => {
    setActiveId(_get(mainData, '[0].id', UNDEFINED_ID));
  }, []);

  const setActive = (item: ICategory) => {
    setActiveId(_get(item, 'id'));
  };
  const contentData = mapSubData[activeId];

  return (
    <>
      <Flex>
        <Sidebar data={mainData} activeId={activeId} setActive={setActive} />
        <Content
          root={_get(contentData, 'root', {})}
          items={_get(contentData, 'items', [])}
        />
      </Flex>
      <HelperLink>
        {categories.map((item) => (
          <ContentItem
            key={_get(item, 'id')}
            href={categoryHref(_get(item, 'id'), _get(item, 'urlKey'))}
            style={{ display: 'inline-block' }}
          >
            <div className="text">{_get(item, 'name')}</div>
          </ContentItem>
        ))}
      </HelperLink>
    </>
  );
};

const Sidebar = memo<{
  data: ICategory[];
  activeId?: number;
  setActive: (item: ICategory) => void;
}>(({ data, activeId, setActive }) => {
  return (
    <SidebarWrapper>
      <SidebarContainer>
        {data?.map((item) => (
          <SidebarItem
            key={_get(item, 'id')}
            className={cn({ active: _get(item, 'id') === activeId })}
            onClick={() => setActive(item)}
          >
            <LazyImage
              src={_get(item, 'imageIcon') || '/assets/art-and-design.svg'}
              alt={_get(item, 'name')}
              width="36"
              className="image"
            />
            <div className="text">{_get(item, 'name')}</div>
          </SidebarItem>
        ))}
      </SidebarContainer>
    </SidebarWrapper>
  );
});

const Content = memo<{
  root?: ICategory;
  items?: ICategory[];
}>(({ root, items }) => {
  return (
    <ContentWrapper>
      <ContentLink href={categoryHref(_get(root, 'id'), _get(root, 'urlKey'))}>
        <span>Xem tất cả</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <path
            fill="var(--primary)"
            fillRule="nonzero"
            d="M13.214 12L8 6.476 9.393 5 16 12l-6.607 7L8 17.524z"
          />
        </svg>
      </ContentLink>
      <ContentContainer>
        {items?.map((item) => (
          <ContentItem
            key={_get(item, 'id')}
            href={categoryHref(_get(item, 'id'), _get(item, 'urlKey'))}
          >
            <LazyImage
              src={_get(item, 'imageIcon') || '/assets/art-and-design.svg'}
              alt={_get(item, 'name')}
              width="36"
              className="image"
            />
            <div className="text">
              {_truncate(_get(item, 'name'), { length: 30 })}
            </div>
          </ContentItem>
        ))}
      </ContentContainer>
    </ContentWrapper>
  );
});

export default Sitemap;
